import * as _ from 'underscore';

import { environment } from '../../../environments/environment';

export class OrderByDirection {
  public static Asc = 'Asc';
  public static Desc = 'Desc';
}

export class View {
  public Offset?: number;
  public Limit?: number;
  public FilterName?: string[];
  public FilterValue?: string[];
  public OrderByField?: string[];
  public OrderByDirection?: OrderByDirection[];
  public RetainOffset: boolean;

  constructor(limit: number = environment.defaultPageSize) {
    this.Limit = limit;
  }

  getFilter(fieldName: string): any {
    if (!this.FilterName) {
      this.FilterName = [];
      this.FilterValue = [];
    }

    const idx = _.indexOf(this.FilterName, fieldName);

    if (idx >= 0) {
      return this.FilterValue[idx];
    }
  }

  public addOrUpdateFilter(fieldName: string, fieldValue: any): void {
    if (!this.FilterName) {
      this.FilterName = [];
      this.FilterValue = [];
    }

    const idx = _.indexOf(this.FilterName, fieldName);

    if (idx < 0) {
      this.FilterName.push(fieldName);
      this.FilterValue.push(fieldValue);
    } else {
      this.FilterValue[idx] = fieldValue;
    }
  }

  public addFilter(fieldName: string, fieldValue: any): void {
    if (!this.FilterName) {
      this.FilterName = [];
      this.FilterValue = [];
    }

    const idx = _.indexOf(this.FilterName, fieldName);

    if (idx < 0) {
      this.FilterName.push(fieldName);
      this.FilterValue.push(fieldValue);
    } else {
      throw new Error('Filter item [' + fieldName + '] already present! Please consider using [addOrUpdateFilter] method');
    }
  }

  public addOrderBy(fieldName: string, direction: OrderByDirection): void {
    if (!this.OrderByField) {
      this.OrderByField = [];
      this.OrderByDirection = [];
    }

    const idx = _.indexOf(this.OrderByField, fieldName);

    if (direction) {
      if (idx < 0) {
        this.OrderByField.push(fieldName);
        this.OrderByDirection.push(direction);
      } else {
        this.OrderByDirection[idx] = direction;
      }
    }
  }

  public removeFilter(fieldName: string): void {
    if (this.FilterName) {
      const idx = _.indexOf(this.FilterName, fieldName);

      if (idx >= 0) {
        this.FilterName.splice(idx, 1);
        this.FilterValue.splice(idx, 1);
      }
    }
  }

  public removeOrderBy(fieldName: string): void {
    if (this.OrderByField) {
      const idx = _.indexOf(this.OrderByField, fieldName);

      if (idx >= 0) {
        this.OrderByField.splice(idx, 1);
        this.OrderByDirection.splice(idx, 1);
      }
    }
  }

  public hasFilter(fieldName: string): boolean {
    if (this.FilterName) {
      const idx = _.indexOf(this.FilterName, fieldName);

      if (idx >= 0) {
        return true;
      }
    }

    return false;
  }

  public copyFromView(view: View): void {
    if (!view) { return; }

    if (view.Limit !== undefined) { this.Limit = view.Limit; } else { if (this.Limit) { this.Limit = undefined; } }
    if (view.Offset !== undefined) { this.Offset = view.Offset; } else { if (this.Offset) { this.Offset = 0; } }

    if (view.FilterName !== undefined) { this.FilterName = view.FilterName.slice(0); } else { this.clearArray(this.FilterName); }
    if (view.FilterValue !== undefined) { this.FilterValue = view.FilterValue.slice(0); } else { this.clearArray(this.FilterValue); }
    if (view.OrderByField !== undefined) { this.OrderByField = view.OrderByField.slice(0); } else { this.clearArray(this.OrderByField); }
    if (view.OrderByDirection !== undefined) { this.OrderByDirection = view.OrderByDirection.slice(0); } else { this.clearArray(this.OrderByDirection); }

    if (view.RetainOffset !== undefined) { this.RetainOffset = view.RetainOffset; } else { this.RetainOffset = false; }
  }

  private clearArray(a: Array<any>): void {
    if (a) {
      while (a.length > 0) { a.pop(); }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/model/view.ts